module.exports = __webpack_public_path__ + "img/chevron-right-double.f6074932.svg";